import {
  RESPONSIBILITY_DETAIL_ROUTE,
  RESPONSIBILITY_HISTORY_ROUTE,
  RESPONSIBILITY_MASTER_ROUTE,
} from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import { Switch } from "react-router-dom";
import { authorizationService } from "services/common-services/authorization-service";
import ResponsibilityDetail from "./ResponsibilityDetail/ResponsibilityDetail";
import ResponsibilityMaster from "./ResponsibilityMaster/ResponsibilityMaster";
import ResponsibilityHistoryView from "./ResponsibilityHistory/ResponsibilityHistoryView";

function ResponsibilityView() {
  const { auth } = authorizationService.useAuthorizedRoute();
  return (
    <Switch>
      <ProtectedRoute
        path={RESPONSIBILITY_MASTER_ROUTE}
        key={RESPONSIBILITY_MASTER_ROUTE}
        component={ResponsibilityMaster}
        auth={auth(RESPONSIBILITY_MASTER_ROUTE)}
      />
      <ProtectedRoute
        path={RESPONSIBILITY_DETAIL_ROUTE}
        key={RESPONSIBILITY_DETAIL_ROUTE}
        component={ResponsibilityDetail}
        auth={auth(RESPONSIBILITY_DETAIL_ROUTE)}
      />
      <ProtectedRoute
        path={RESPONSIBILITY_HISTORY_ROUTE}
        key={RESPONSIBILITY_HISTORY_ROUTE}
        component={ResponsibilityHistoryView}
        auth={auth(RESPONSIBILITY_HISTORY_ROUTE)}
      />
    </Switch>
  );
}

export { ResponsibilityMaster, ResponsibilityDetail };
export default ResponsibilityView;
